import React, { useState, useEffect } from 'react'
import { connect } from 'react-redux'
import { Button, Col, Container, Spinner } from 'react-bootstrap'
import "../../styles/multipliers-styles.scss"
import FeatherIcon from 'feather-icons-react';
import { setGlobalLoading } from 'redux/actions/actionCommon'
import FormBrandMultiplier from "./Includes/FormBrandMultiplier"
import { toast } from 'react-toastify';
import {
    UNKNOWN_ERROR_OCCURED,
    ERROR_WHILE__NAME,
} from 'utlis/AppMessages/AppMessages'
import { getBrands } from 'utlis/Apis/Brands_API';
import { Link } from 'react-router-dom';
import { ERROR_WHILE_FETCHING_BRANDS } from 'utlis/AppMessages/AppMessages';
import { updateBrandMultiplier } from 'utlis/Apis/Multipliers_API';
import { ERROR_WHILE_UPDATING_BRAND } from 'utlis/AppMessages/AppMessages';
import { ERROR_WHILE_CREATING_BRAND } from 'utlis/AppMessages/AppMessages';
import { BRAND_MULTIPLIERS_UPDATED_SUCCESSFULLY } from 'utlis/AppMessages/AppMessages';
import useStoreUrl from 'utlis/CustomHooks/useStoreUrl';


function BrandMultiplier(props) {
    // props
    const { authState } = props

    const [brands, setBrands] = useState([])
    const [brandsLoading, setBrandsLoading] = useState(false)
    const brandsLoadingIndicator = [1, 2]
    const [multipliers, setMultipliers] = useState([])
    const [multiplierLoading, setMultiplierLoading] = useState(false)

    // store url
    const [storeUrl] = useStoreUrl()

    useEffect(() => {
        setBrandsLoading(true)
        const headers = {
            "Authorization": `Bearer ${authState.commonToken}`,
            "Api-Token": authState.apiToken,
            "Access-Token": "",
            // "Store-Id": authState.storeId,
        }

        getBrands(headers).then(res => {
            setBrandsLoading(false)

            const catsData = res.data
            if (catsData.success) {
                window.scrollTo(0, 0)
                setBrands(catsData.data)
                const array = []
                catsData.data.forEach(e => {
                    array.push({
                        brand_id: e.manufacturer_id, // brand_id
                        b_multiplier: e.multiplier || 0,
                        b_multiplier_type: e.multiplier_type || "percent"
                    })
                })
                setMultipliers(array)
            }

            if (catsData.error) {
                console.log(ERROR_WHILE_CREATING_BRAND, res)

                toast.dismiss();
                toast.error(ERROR_WHILE_CREATING_BRAND, {
                    autoClose: 3000,
                })
            }
        }).catch(err => {
            console.log(`${ERROR_WHILE__NAME} getBrands`, err.message)
            toast.dismiss();
            toast.error(UNKNOWN_ERROR_OCCURED, {
                autoClose: 2500,
                onClose: () => {
                    setBrandsLoading(false)

                }
            })
        })
    }, [authState])


    const updateMultiplier = (id, multiplier, type) => {
        const newArray = multipliers.filter(e => parseInt(e.brand_id) !== parseInt(id))
        newArray.push({
            brand_id: id,
            b_multiplier: multiplier,
            b_multiplier_type: type
        })
        setMultipliers(newArray)
    }
    const updateMultipliers = () => {
        setMultiplierLoading(true)
        const headers = {
            "Authorization": `Bearer ${authState.commonToken}`,
            "Api-Token": authState.apiToken,
            "Access-Token": "",
            // "Store-Id": authState.storeId,
        }
        updateBrandMultiplier(headers, multipliers).then(res => {
            const resData = res.data
            window.scrollTo(0, 0)
            if (resData && resData.success) {
                toast.success(BRAND_MULTIPLIERS_UPDATED_SUCCESSFULLY, {
                    autoClose: 3000
                })
                setMultiplierLoading(false)
            }

            // if request is not succesfull
            if (resData && resData.error) {
                // dismissing all the previous toasts first
                toast.dismiss();
                // showing the error message
                toast.error(ERROR_WHILE_UPDATING_BRAND, {
                    autoClose: 3000,
                    onClose: () => {
                        // disabling loading

                    }
                })
            }
        })

    }

    const getBrands_ = () => {
        setBrandsLoading(true)
        setBrands([])
        setMultipliers([])
        const headers = {
            "Authorization": `Bearer ${authState.commonToken}`,
            "Api-Token": authState.apiToken,
            "Access-Token": "",
            // "Store-Id": authState.storeId,
        }
        getBrands(headers).then(res => {
            // disabling section loading & loading
            setBrandsLoading(false)

            const resData = res.data
            setBrands([])
            // scroll the page to the top
            window.scrollTo(0, 0)

            // if request succesfull
            if (resData && resData.success) {
                // settings products
                setBrands(resData.data)
                const multies = []
                resData.data.forEach(e => {
                    multies.push({
                        brand_id: e.manufacturer_id,
                        b_multiplier: e.multiplier || 0,
                        b_multiplier_type: e.multiplier_type || "percent"
                    })
                })
                setMultipliers(multies)

            }

            // if request is not succesfull
            if (resData && resData.error) {
                // dismissing all the previous toasts first
                toast.dismiss();

                // showing the error message
                toast.error(ERROR_WHILE_FETCHING_BRANDS, {
                    autoClose: 3000,
                    onClose: () => {
                        // disabling loading
                        setBrandsLoading(false)
                    }
                })
            }
        })
    }

    return (
        <section id="app-multipliers" className="st-def-mar-TB page-eorc-wrapper">
            <Container fluid className="st-container">
                <div className="app-brand-multipliers">
                    <Link
                        className="st-btn st-btn-link text-primary border-light bg-transparent no-min-width st-btn-sm p-0 min-height-auto"
                        to={storeUrl + "/catalog/multipliers"}
                    >
                        <FeatherIcon
                            icon="arrow-left"
                            size="14"
                            className="icon me-2" />
                        <span>Back</span>
                    </Link>
                    <div className="app-header-brand mb-3">
                        <p className="app-heading text-capitalize">Brand Multiplier</p>
                        <p className="app-desc">Setup of Brand Multipliers</p>
                    </div>
                    <Col xs={12} md={12} lg={11} className="px-0">
                        <div className="app-card">
                            <div className="app-card-content border st-default-rounded-block pad-20">
                                <div className="app-card">
                                    <div className="app-header-wrapper d-flex justify-content-between mb-2   pb-1 pad-25-R pad-25-L">
                                        <p className="app-multiplier-desc">Brand</p>
                                        <p className="app-multiplier-desc">Brand Multiplier</p>
                                    </div>
                                    <div className="app-card-content">
                                        <Col xs={12} md={9} lg={12} className="px-0">
                                            <FormBrandMultiplier
                                                brandsLoading={brandsLoading}
                                                brands={brands}
                                                brandsLoadingIndicator={brandsLoadingIndicator}
                                                getBrands_={getBrands_}
                                                multipliers={multipliers}
                                                updateMultiplier={updateMultiplier}
                                            />
                                            <div className="d-flex justify-content-end mt-4">
                                                <div className="cats-all-btns-inner d-flex flex-wrap align-items-center justify-content-between">
                                                    <div className="cats-all-btns-right d-flex flex-wrap  justify-content-start align-items-center">
                                                        <Button
                                                            className="st-btn st-btn-gray no-min-width st-btn-sm d-flex align-items-center justify-content-center btn btn-primary me-2">
                                                            <FeatherIcon
                                                                icon="rotate-cw"
                                                                size="14"
                                                                className="icon me-2" />
                                                            <span>Reset</span>
                                                        </Button>
                                                        <Button
                                                            onClick={updateMultipliers}
                                                            className="st-btn st-btn-primary no-min-width st-btn-sm d-flex align-items-center justify-content-center btn btn-primary">
                                                            {
                                                                multiplierLoading ? (
                                                                    <Spinner animation="border" size="sm" />
                                                                ) : (
                                                                    <>
                                                                        <FeatherIcon
                                                                            icon="download"
                                                                            size="14"
                                                                            className="icon me-2" />
                                                                        <span>Save</span>
                                                                    </>)
                                                            }
                                                        </Button>
                                                    </div>
                                                </div>
                                            </div>
                                        </Col>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Col>
                </div>
            </Container >
        </section >
    )
}

const getDataFromStore = state => {
    return {
        authState: state.auth
    };
}

const dispatchActionsToProps = dispatch => {
    return {
        setGlobalLoading: bool => dispatch(setGlobalLoading(bool)),
    }
}

export default connect(getDataFromStore, dispatchActionsToProps)(BrandMultiplier)